module.exports = __webpack_public_path__ + "static/sport/btn-register.1efabe2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/btn-register.gif
// module id = uSEO
// module chunks = 0